export default __webpack_public_path__ + "static/studycafe-office7-044e819b2ed970eed46efdffd5ae6c55.jpg";